const colors = {
  background: {
    gray4: '#666',
  },
};

export const useStyles = {
  container: {
    padding: '0px 24px',
    width: '100%',
  },
  cropper: {
    height: '500px',
    width: '100%',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    marginTop: '24px',
  },
  button: {
    marginRight: '10px',
    color: colors.background.gray4,
  },
};
